namespace Gamification.Gamification {
    export enum ApiScriptUtenteMostraTaskEnum {
        Task_Tutti = 1,
        Task_Portati_A_Termine = 2,
        Task_Non_Portati_A_Termine = 3
    }
    Serenity.Decorators.registerEnumType(ApiScriptUtenteMostraTaskEnum, 'Gamification.Gamification.ApiScriptUtenteMostraTaskEnum');
}
